import { Box } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import { FinancialProjectSelector } from 'modules/project_management/components/selectors/FinancialProjectSelector'

import { SaleInvoiceFormFields } from './types'

interface ProjectSectionProps {
  form: FormikProps<SaleInvoiceFormFields>
  readOnlyProject: boolean
  readOnlySubproject: boolean
}

export const ProjectSection: React.FC<ProjectSectionProps> = ({
  form,
  readOnlyProject,
  readOnlySubproject,
}) => {
  return (
    <Box
      gap="s16"
      flexDirection="row"
      style={{
        width: form.values?.project ? '100%' : '50%',
        paddingRight: form.values?.project ? '0' : '8px',
      }}
    >
      <FinancialProjectSelector
        value={form.values?.project || null}
        onChange={(project) => {
          form.setValues({ ...form.values, project, subproject: null })
        }}
        subprojectValue={form.values?.subproject || null}
        onChangeSubproject={(subproject) => {
          form.setValues({ ...form.values, subproject })
        }}
        billable
        projectDisabled={readOnlyProject}
        subprojectDisabled={readOnlySubproject}
        hideSearchIcon
      />
    </Box>
  )
}
